/**
 * Computes the savings rate as a percentage of income.
 * Formula: ((totalIncome - totalExpenses) / totalIncome) * 100
 *
 * @param totalIncome    - Total income for the period (must be > 0)
 * @param totalExpenses  - Total expenses for the period
 */
export function computeSavingsRate(totalIncome: number, totalExpenses: number): number {
  return ((totalIncome - totalExpenses) / totalIncome) * 100;
}

/**
 * Computes the month-over-month percentage change in a value.
 * Formula: ((current - previous) / previous) * 100
 *
 * @param current   - Current period value
 * @param previous  - Previous period value (must be > 0)
 */
export function computeMoMChange(current: number, previous: number): number {
  return ((current - previous) / previous) * 100;
}
